export default __webpack_public_path__ + "static/media/shop-active-tab-icon.34e5031d.svg";